import { useEffect, useMemo } from "react";

import constants from "../../constants";
import { getStoreColorVariables } from "../../lib/storeTheme";

const GOOGLE_FONTS_MAP = {
  Nunito: "Nunito:wght@400;500;600;700",
  Pacifico: "Pacifico:wght@400",
  Roboto: "Roboto:wght@400;500;700",
  "Roboto Mono": "Roboto+Mono:wght@400;500;700",
  Lobster: "Lobster:wght@400",
  Lora: "Lora:wght@400;500;600;700",
  Merriweather: "Merriweather:wght@400;700",
  Montserrat: "Montserrat:wght@400;500;600;700",
  Caveat: "Caveat:wght@400;500;600;700",
  "EB Garamond": "EB+Garamond:wght@400;500;600;700",
  "Playfair Display": "Playfair+Display:wght@400;500;600;700",
  Oswald: "Oswald:wght@400;500;600;700",
};

export default function ThemeProvider({ children, themeData }) {
  const primary = themeData?.primary;
  const colorVariables = useMemo(() => getStoreColorVariables(primary), [primary]);
  const configuredFont = GOOGLE_FONTS_MAP[themeData?.font] ? themeData.font : null;
  const font = configuredFont || constants.fontFamily.defaultFont;

  useEffect(() => {
    const root = document.documentElement;
    const variables = colorVariables || {};
    Object.entries(variables).forEach(([name, value]) => root.style.setProperty(name, value));

    return () => Object.keys(variables).forEach((name) => root.style.removeProperty(name));
  }, [colorVariables]);

  useEffect(() => {
    const root = document.documentElement;
    const fontQuery = GOOGLE_FONTS_MAP[font];
    document.querySelector("link[data-font-loader]")?.remove();

    if (fontQuery) {
      const link = document.createElement("link");
      link.href = `https://fonts.googleapis.com/css2?family=${fontQuery}&display=swap`;
      link.rel = "stylesheet";
      link.setAttribute("data-font-loader", "true");
      document.head.appendChild(link);
      root.style.setProperty("--font-family", `"${font}", sans-serif`);
      root.style.setProperty("--font-montserrat", `"${font}", sans-serif`);
    } else {
      root.style.removeProperty("--font-family");
      root.style.removeProperty("--font-montserrat");
    }

    return () => {
      document.querySelector("link[data-font-loader]")?.remove();
      root.style.removeProperty("--font-family");
      root.style.removeProperty("--font-montserrat");
    };
  }, [font]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
